import Button from '@superfunnel/ui-core/v2/Button';
import { classNames } from '@superfunnel/utils';
import { ArrowRight, ChatBubbleWarning, WarningTriangle } from 'iconoir-react';
import { ChatMessage } from '../../types/agentChat';

interface ErrorMessageProps {
  message: ChatMessage;
  onRetry?: (errorType: 'error' | 'limitReached') => void;
}

export function ErrorMessage({ message, onRetry }: ErrorMessageProps) {
  const isRecursionLimit =
    message.metadata?.code === 'RECURSION_LIMIT' ||
    message.content.toLowerCase().includes('recursion') ||
    message.content.toLowerCase().includes('max length limit');

  const config = isRecursionLimit
    ? {
        icon: <ChatBubbleWarning className="text-brand-600 h-5 w-5" />,
        textColor: 'text-brand-600',
        buttonText: 'Continue',
        errorText: 'Recursion limit reached.',
        errorType: 'limitReached' as const,
      }
    : {
        icon: <WarningTriangle className="h-5 w-5 text-[#f62c2c]" />,
        textColor: 'text-[#f62c2c]',
        buttonText: 'Try again',
        errorText: message.content.startsWith('Error:')
          ? message.content
          : `Error: ${message.content}`,
        errorType: 'error' as const,
      };

  return (
    <div
      className="font-inter mt-2 flex min-h-11 items-center justify-between rounded-xl border py-1 pr-2 pl-3"
      style={{
        background:
          'linear-gradient(113.22deg, rgba(255, 255, 255, 0.4) 10.7%, #FFFFFF 116.64%)',
        borderImageSource:
          'linear-gradient(95.57deg, rgba(255, 255, 255, 0.3) 10.18%, #FFFFFF 87.97%)',
      }}
    >
      <div className="flex items-center gap-2.5">
        <div className="shrink-0">{config.icon}</div>
        <p className={classNames('text-sm tracking-tight', config.textColor)}>
          {config.errorText}
        </p>
      </div>
      {onRetry && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onRetry(config.errorType)}
        >
          <span className="text-xs text-[#141C25]">{config.buttonText}</span>
          <ArrowRight className="size-4 text-[#141C25]" />
        </Button>
      )}
    </div>
  );
}
